export const Apps = {
    Default: 0,
    Goforest: 1
};